interface LoadSceneOptionalParams {
  planet?: boolean;
}

export const setAutoRotate = (value: boolean) => {
  window.toggle_autorotate(value);
};

const toggleSceneHotSpot = (value: boolean) => {
  window.toggle_scene_hotspot({ show: value });
};

const _loadScene = (() => {
  let loaded = false;
  return (name: string) => {
    const params: LoadSceneOptionalParams = {};
    if (!loaded) {
      params.planet = true;
      loaded = true;
      console.log('load first scene');
    }
    window.loadscene({
      scenename: name,
      ...params,
    });
    /**
     * todo
     * 解决问题：行星入场后不展示热点
     * 原因分析：行星入场的选项为了避免热点影响旋转的效果，会把所有热点隐藏掉
     * 临时方案： 行星入场的动画时间是3秒，三秒后window.toggle_scene_hotspot({show: value})（后续还需解决）
     */
    setTimeout(() => {
      toggleSceneHotSpot(true);
    }, 3000);
  };
})();

export const loadScene = (name: string) => {
  if (window.__krpano) {
    return _loadScene(name);
  }
  // 处理krpano未初始化时就调用加载场景
  let exec = false;
  const timer = setInterval(() => {
    if (exec) {
      clearInterval(timer);
    } else if (window.__krpano) {
      _loadScene(name);
      exec = true;
      clearInterval(timer);
    }
  }, 1000);
};
